import { useQuery } from 'react-query';
import HttpService from 'services/httpService';
import { ENDPOINT_BASE_URL } from './constants';
import { useAuth } from './useAuth';
import { ExamTypes, FullJoints, ViewTypeData, ViewTypes } from 'models/XrayModels';

export type ReqViewsByAppointment = Record<ExamTypes, { [VT in ViewTypes]?: ViewTypeData<VT> }>

// see this section of the notion documentation for more information on how react query is utilized in this project:
// https://www.notion.so/JointAi-Comprehensive-Documentation-e8b94dcf09064573af647df6557b7bd1?pvs=4#074ef550cfc14c11b1b5488f0d8c5fff

export const appointmentQueryKeys = {
  appointmentRequiredJointViews: (appointmentId: string | undefined | null, dateISOString: string | undefined | null) => ['appointmentRequiredJointViews', { appointmentId, activeDate: dateISOString }],
};

export interface RequiredView {
  key: ViewTypes;
  label: string;
  value: string | string[]; // accion view type values per the documentation
  isOptional?: boolean;
}
export type RequiredViews = Record<ViewTypes, RequiredView>

// Main response type for get_appointment_exams
export interface GetAppointmentRequiredJointViewsResponse {
  joint_views: Record<FullJoints, RequiredViews>; // Maps exam types to their views & missing items
}

interface UseAppointmentRequiredJointViewsDataOptions {
  selectedDateISOString?: string | null;
  appointmentId?: string | null;
}

export const useAppointmentRequiredJointViewsData = (opts?: UseAppointmentRequiredJointViewsDataOptions) => {
  const { user, accessToken } = useAuth();

  const date = opts?.selectedDateISOString;
  const appointmentId = opts?.appointmentId;

  const getAppointmentRequiredJointViews = async ({ queryKey }: any) => {
    const [, { appointmentId, activeDate }] = queryKey;

    const data = await HttpService.get<GetAppointmentRequiredJointViewsResponse>({
      url: `${ENDPOINT_BASE_URL}/appointments/required-views/${appointmentId}?org_id=${user?.orgs[0].org_id}&appointment_date=${activeDate}`,
      token: accessToken,
    });

    return data;
  };

  const {
    data: appointmentRequiredJointViewsData,
    error: appointmentRequiredJointViewsError,
    isLoading: appointmentRequiredJointViewsLoading,
    refetch: refetchAppointmentRequiredJointViews,

  } = useQuery(
    appointmentQueryKeys.appointmentRequiredJointViews(appointmentId, date),
    getAppointmentRequiredJointViews);

  const appointmentRequiredJointViews = appointmentRequiredJointViewsData?.data?.joint_views;

  return {
    appointmentRequiredJointViews,
    appointmentRequiredJointViewsError,
    appointmentRequiredJointViewsLoading,
    refetchAppointmentRequiredJointViews,
  };
};
